import {
  Activity, ArrowDownToLine, ChartNoAxesCombined, CircleDollarSign, Database, CalendarRange,
  Coins, FileClock, LayoutDashboard, LogOut, Network, Search, Send, UsersRound
} from "lucide-react";
import { BrandLogo, SecondaryButton, StatusPill } from "@ocs/ui";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../api";

const nav = [
  { to: "/", label: "总览", icon: LayoutDashboard, end: true },
  { to: "/market-operations", label: "Market 监控", icon: ChartNoAxesCombined },
  { to: "/deposits", label: "实时入金", icon: ArrowDownToLine },
  { to: "/treasury-flows", label: "Treasury Flow", icon: Coins },
  { to: "/withdrawals", label: "实时提现", icon: Send },
  { to: "/daily-rewards", label: "每日收益统计", icon: CalendarRange },
  { to: "/nodes", label: "用户收益查询", icon: UsersRound },
  { to: "/referral-network", label: "推荐关系查询", icon: Network },
  { to: "/liquidity", label: "合约流动性", icon: CircleDollarSign },
  { to: "/settlements", label: "周结算", icon: FileClock },
  { to: "/transfers", label: "多签调拨", icon: Network },
  { to: "/genesis", label: "创世账户", icon: Database }
];

const titles: Record<string, string> = {
  "/": "运营总览",
  "/market-operations": "Market 运营与风控",
  "/deposits": "实时入金",
  "/treasury-flows": "Treasury Token 实时流水",
  "/withdrawals": "实时提现",
  "/daily-rewards": "每日收益统计与领取分析",
  "/nodes": "用户收益与节点数据",
  "/referral-network": "账户推荐关系与仓位",
  "/liquidity": "合约流动性",
  "/settlements": "每周手续费分红",
  "/transfers": "TP Wallet 多签调拨",
  "/genesis": "创世推荐账户"
};

export function AdminShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const logout = useMutation({
    mutationFn: () => adminApi("/auth/logout", { method: "POST" }),
    onSettled: () => {
      queryClient.clear();
      navigate("/login");
    }
  });
  return (
    <div className="admin-shell">
      <a href="#admin-main" className="skip-link">跳到主要内容</a>
      <aside className="admin-sidebar">
        <BrandLogo />
        <div className="console-label"><Activity size={14} />OPERATIONS CONSOLE</div>
        <nav aria-label="数据中台导航">
          {nav.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}>
              <Icon size={18} aria-hidden /><span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-status">
          <StatusPill tone="success">API 已连接</StatusPill>
          <SecondaryButton type="button" disabled={logout.isPending} onClick={() => logout.mutate()}>
            <LogOut size={16} />{logout.isPending ? "退出中…" : "退出"}
          </SecondaryButton>
        </div>
      </aside>
      <section className="admin-workspace">
        <header className="admin-topbar">
          <div><p>OnChainSage / OPERATIONS</p><h1>{titles[location.pathname] ?? "数据中台"}</h1></div>
          <div className="topbar-tools">
            <label className="quick-search"><Search size={16} /><input placeholder="钱包地址 / 交易哈希" /></label>
            <StatusPill>5 秒刷新</StatusPill>
          </div>
        </header>
        <main id="admin-main"><Outlet /></main>
      </section>
    </div>
  );
}
